interface PlaybookEmptyProgramSvgProps {
  size?: number;
  color?: string;
}

export function PlaybookEmptyProgramSvg({
  size = 60,
  color = "#E6F1FD",
}: PlaybookEmptyProgramSvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 62 60"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.5 13.8048L56.7487 18.9823L52.5336 14.389C52.4504 20.3209 51.09 24.6665 48.3492 27.6604C44.5598 31.7996 39.0633 32.295 34.7234 32.3683C33.586 32.3875 32.4396 32.3747 31.3531 32.3637C30.2493 32.3525 29.204 32.3428 28.1866 32.3611C26.128 32.3983 24.4106 32.5522 22.988 32.9505C21.6188 33.3338 20.6341 33.9111 19.8995 34.7553C19.6471 35.0455 19.3972 35.3992 19.1621 35.8346C23.5807 37.8073 26.6592 42.2291 26.6593 47.3682C26.6593 54.3443 20.9868 60 13.9897 60C6.99273 59.9999 1.32064 54.3442 1.32064 47.3682C1.32075 41.0913 5.91294 35.8841 11.9304 34.9033C12.5517 33.0659 13.4312 31.4839 14.5839 30.159C16.4286 28.0387 18.7331 26.8517 21.0838 26.1935C23.3815 25.5501 25.8174 25.3845 28.0607 25.344C29.1935 25.3236 30.3368 25.335 31.4239 25.3461C32.5292 25.3573 33.5792 25.368 34.6043 25.3507C38.9145 25.2778 41.5529 24.6746 43.1507 22.9294C44.3479 21.6216 45.4747 19.084 45.4991 13.984L40.9126 18.9823L36.1614 13.8048L48.8309 0L61.5 13.8048ZM13.9897 41.7545C10.8801 41.7546 8.35936 44.2678 8.35924 47.3682C8.35924 50.4687 10.88 52.9823 13.9897 52.9824C17.0995 52.9824 19.6207 50.4688 19.6207 47.3682C19.6206 44.2677 17.0994 41.7545 13.9897 41.7545Z"
        fill={color}
      />
      <path
        d="M59.2425 39.8007L52.8134 46.2105L59.4114 52.7888L54.4347 57.7513L47.8362 51.1724L41.2382 57.7513L36.261 52.7888L42.8595 46.2105L36.4304 39.8007L41.4072 34.8382L47.8362 41.2486L54.2652 34.8382L59.2425 39.8007Z"
        fill={color}
      />
      <path
        d="M23.4815 5.31314L17.0525 11.723L23.6505 18.3013L18.6737 23.2637L12.0752 16.6849L5.47673 23.2637L0.5 18.3013L7.0985 11.723L0.668955 5.31314L5.6462 0.350727L12.0752 6.76059L18.5043 0.350727L23.4815 5.31314Z"
        fill={color}
      />
    </svg>
  );
}
